export const CREATE_DEAL_IDENTIFIER = 'create-deal-modal';
export const VEHICLE_OF_INTEREST_LABEL = 'Vehicle of Interest (required)';
export const NO_VEHICLE_SELECTED = 'no vehicle selected';
